import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Column,
  Heading,
  Row,
  Button,
} from '@chargify/custom-ui-components';

import { ComponentGroup } from '../ComponentGroup';

import { SubscriptionComponent } from './types';
import { ComponentLoadingSkeleton } from './components';

export type Props = {
  prepaid?: SubscriptionComponent[];
  metered?: SubscriptionComponent[];
  onOff?: SubscriptionComponent[];
  quantity?: SubscriptionComponent[];
  selfServiceEnabled: boolean;
  onEditAddons: () => void;
};

const SubscriptionComponents = ({
  prepaid,
  metered,
  onOff,
  quantity,
  selfServiceEnabled,
  onEditAddons,
}: Props) => {
  const { t } = useTranslation(['subscriptions-manager']);
  return (
    <>
      {(quantity || onOff || selfServiceEnabled) && (
        <Box marginBottom={[3, 3, 7]}>
          <Row rowGap={[8, 8, 16]}>
            <Column span={[24, 7]}>
              <Heading variant="h4">
                {t('subscription_components.add_ons')}
              </Heading>
            </Column>
            <Column span={[24, 17]}>
              {onOff && <ComponentGroup components={onOff} />}
              {quantity && <ComponentGroup components={quantity} />}
              {selfServiceEnabled && (
                <Box marginTop={2}>
                  <Button
                    label={t('components_allocations.configure_add_ons')}
                    onClick={onEditAddons}
                    color="secondary"
                    size="medium"
                    iconLeft="edit"
                  />
                </Box>
              )}
            </Column>
          </Row>
        </Box>
      )}
      {(prepaid || metered) && (
        <Row rowGap={[8, 8, 16]}>
          <Column span={[24, 7]}>
            <Heading variant="h4">{t('subscription_components.usage')}</Heading>
          </Column>
          <Column span={[24, 17]}>
            {prepaid && (
              <ComponentGroup components={prepaid} renderInCard={false} />
            )}
            {metered && <ComponentGroup components={metered} />}
          </Column>
        </Row>
      )}
    </>
  );
};

SubscriptionComponents.LoadingSkeleton = ComponentLoadingSkeleton;

export default SubscriptionComponents;
